module.exports = __webpack_public_path__ + "img/salir.cf0d4e48.svg";